module.exports = __webpack_public_path__ + "img/Entia-Infraestructura-Ferroviaria-9.3f657d80.webp";